<template>
  <header>
    <template v-if="screen === 2">
      <div class="header flex">
        <div class="logo flex-y-center">
          <img src="@/assets/img/logo.png" alt="logo">
        </div>
        <nav class="flex">
          <router-link
            :key="i"
            :to="nav.link ? nav.link : {name: nav.name, params: nav.params}"
            active-class="is-active"
            class="nav-item flex-center"
            v-for="(nav, i) in navLink"
          >{{nav.label}}</router-link>
        </nav>
      </div>
    </template>
    <template v-else>
      <div class="expand flex-y-center">
        <img class="logo" src="@/assets/img/logo.png" alt="logo">
        <img class="expand-img" src="@/assets/img/expand.png" @click="isExpand = !isExpand"/>
      </div>
      <div :class="['sidebar', isExpand ? 'is-expand' : '']" v-if="isExpand">
        <ul class="flex-column flex-y-center sidebar-list">
          <li :key="i" v-for="(nav, i) in navLink">
            <router-link
              :to="nav.link ? nav.link : {name: nav.name, params: nav.params}"
              active-class="is-active"
              class="nav-item flex-center"
            >{{nav.label}}</router-link>
          </li>
        </ul>
        <div class="sidebar-mask" @click="isExpand = false"></div>
      </div>
    </template>
  </header>
</template>

<script>
import { defineComponent, reactive, ref, onMounted, computed } from "vue"
import navLinkList from './utils/navLink.js'
import { useScreenStore } from '@/store'

export default defineComponent({
  name: "Header",
  setup() {
    const navLink = reactive(navLinkList)
    const isExpand = ref(false)
    const store = useScreenStore()
    onMounted(() => {
      // console.log(store.screen)
    })
    return {
      navLink,
      isExpand,
      screen: computed(() => store.screen)
    }
  }
})
</script>

<style lang="scss" scoped>
header {
  background-color: #fff;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  box-shadow: 0px 0px 20px 0px rgba(194, 194, 194, 0.4);
  .header {
    width: 1200px;
    height: 70px;
    margin: 0 auto;
    .logo {
      margin-right: 50px;
      img {
        width: 94px;
        height: 38px;
      }
    }
    .nav-item {
      padding: 0 10px;
      font-weight: 500;
      white-space: nowrap;
      &:not(:last-child) {
        margin-right: 30px;
      }
      &.is-active,
      &:hover {
        border-bottom: 3px solid #3D58A7;
      }
    }
  }
  .expand {
    display: none;
    height: 70px;
    padding: 0 20px;
    justify-content: space-between;
    img.logo {
      width: 94px;
      height: 38px;
    }
    .expand-img {
      width: 30px;
      height: 30px;
      cursor: pointer;
    }
  }
  .sidebar {
    position: fixed;
    top: 0;
    z-index: 99;
    &-mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
    }
    &-list {
      position: fixed;
      width: 40vw;
      background-color: #fff;
      top: 0;
      right: -40vw;
      bottom: 0;
      z-index: 100;
      li {
        width: 100%;
        height: 40px;
        line-height: 40px;
        & > a {
          &.is-active {
            // border-bottom: 3px solid #3D58A7;
            color: #fff;
            background-color: rgba(61, 88, 167, 1);
          }
        }
      }
    }
    &.is-expand {
      @keyframes rtl-drawer-in {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-100%);
        }
      }
      .sidebar-list {
        animation: rtl-drawer-in .3s 1ms;
        animation-fill-mode: forwards;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  header {
    .header {
      display: none;
    }
    .expand {
      display: flex;
    }
  }
}
</style>